import { render, staticRenderFns } from "./param-edit.vue?vue&type=template&id=4544d351&scoped=true"
import script from "./param-edit.vue?vue&type=script&lang=ts"
export * from "./param-edit.vue?vue&type=script&lang=ts"
import style0 from "./param-edit.vue?vue&type=style&index=0&id=4544d351&prod&lang=scss&scoped=true"
import style1 from "./param-edit.vue?vue&type=style&index=1&id=4544d351&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4544d351",
  null
  
)

export default component.exports